// extracted by mini-css-extract-plugin
module.exports = {"countLabel":"StoreLocatorCount_countLabel__6zPWl"};